import { render, staticRenderFns } from "./UpcomingTrips.vue?vue&type=template&id=33d279c9&"
import script from "./UpcomingTrips.vue?vue&type=script&lang=js&"
export * from "./UpcomingTrips.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingTrips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports